export type SearchTab = 'orders' | 'sessions'

/**
 * The search page's URL state (G13): the tab and the criteria last submitted, so a result
 * survives opening it and coming back. Strings as typed; the page validates before it asks.
 */
export interface SearchPageSearch {
  tab: SearchTab
  code?: string
  number?: string
  date?: string
  table?: string
  time?: string
}

export type OrderSearchCriteria = { code: string } | { number: string; date: string }
export type SessionSearchCriteria = { code: string } | { table: string; date: string; time?: string }

const str = (value: unknown): string | undefined => (typeof value === 'string' && value !== '' ? value : undefined)

export function parseSearchPageSearch(search: Record<string, unknown>): SearchPageSearch {
  const out: SearchPageSearch = { tab: search.tab === 'sessions' ? 'sessions' : 'orders' }
  for (const key of ['code', 'number', 'date', 'table', 'time'] as const) {
    const value = str(search[key])
    if (value !== undefined) out[key] = value
  }
  return out
}

/** What the orders tab asked for if anything valid is in the URL. */
export function orderCriteria(search: SearchPageSearch): OrderSearchCriteria | undefined {
  if (search.code) return { code: search.code }
  if (search.number && search.date) return { number: search.number, date: search.date }
  return undefined
}

export function sessionCriteria(search: SearchPageSearch): SessionSearchCriteria | undefined {
  if (search.code) return { code: search.code }
  if (search.table && search.date) return { table: search.table, date: search.date, ...(search.time ? { time: search.time } : {}) }
  return undefined
}

/** Mirrors `PublicCode` (T6): ten characters of the unambiguous alphabet, typed in any case. */
const CODE = /^[23456789ABCDEFGHJKMNPQRSTUVWXYZ]{10}$/

export function normalizeCode(raw: string): string | undefined {
  const code = raw.trim().toUpperCase()
  return CODE.test(code) ? code : undefined
}

export function isOrderNumber(raw: string): boolean {
  return /^\d+$/.test(raw.trim()) && Number(raw) > 0
}
